
import $ from '@ali/tarzan-zepto';
import tpl from './tpl.html';

require('./style.scss');

export default class Tip {

  constructor(config) {
    const $root = $(tpl.render({
      content: config.content,
    }));

    $root.on('tap', () => {
      this.hide();
    });

    $(document.body).append($root);

    this.$root = $root;
    this.timer = setTimeout(() => {
      this.hide();
    }, config.interval || 5000);
  }

  hide() {
    this.$root.animate({
      opacity: 0,
    }, 500, 'ease-out', () => {
      if (this.timer) {
        clearTimeout(this.timer);
        this.$root.unbind('tap', this.hide);
        this.$root.remove();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/component/view/footer/tip/index.js